export abstract class  BusquedaGeoreferencia{
  public abstract getBusquedaEstructurada(): string;
  public abstract getBusquedaSimple(): string;
}
